import React from 'react';
import { Check, X } from 'lucide-react';

const permissions = [
  { id: 'perm-create-campaigns', action: 'Create & launch campaigns', admin: true, manager: true, editor: false },
  { id: 'perm-edit-campaigns', action: 'Edit active campaigns', admin: true, manager: true, editor: false },
  { id: 'perm-pause-campaigns', action: 'Pause / resume campaigns', admin: true, manager: true, editor: false },
  { id: 'perm-delete-campaigns', action: 'Delete campaigns', admin: true, manager: false, editor: false },
  { id: 'perm-schedule-posts', action: 'Schedule & edit content posts', admin: true, manager: true, editor: true },
  { id: 'perm-approve-posts', action: 'Approve content for publishing', admin: true, manager: true, editor: false },
  { id: 'perm-view-analytics', action: 'View page analytics', admin: true, manager: true, editor: true },
  { id: 'perm-export-reports', action: 'Export analytics reports', admin: true, manager: true, editor: false },
  { id: 'perm-manage-clients', action: 'Add / remove client accounts', admin: true, manager: false, editor: false },
  { id: 'perm-invite-members', action: 'Invite team members', admin: true, manager: false, editor: false },
  { id: 'perm-assign-roles', action: 'Assign & change roles', admin: true, manager: false, editor: false },
  { id: 'perm-connect-pages', action: 'Connect Facebook / Instagram pages', admin: true, manager: true, editor: false },
];

function CheckCell({ has }: { has: boolean }) {
  return (
    <td className="px-4 py-2.5 text-center">
      {has ? (
        <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-positive/10">
          <Check size={11} className="text-positive" />
        </span>
      ) : (
        <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-muted">
          <X size={11} className="text-muted-foreground" />
        </span>
      )}
    </td>
  );
}

export default function RolePermissionMatrix() {
  return (
    <div className="card-base overflow-hidden">
      <div className="px-6 py-4 border-b border-border">
        <h3 className="text-base font-semibold text-foreground">Role Permissions</h3>
        <p className="text-xs text-muted-foreground mt-0.5">What each role can do across client accounts</p>
      </div>
      <div className="overflow-x-auto scrollbar-thin">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border bg-muted/30">
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Permission</th>
              <th className="px-4 py-3 text-center">
                <span className="badge-admin">Admin</span>
              </th>
              <th className="px-4 py-3 text-center">
                <span className="badge-manager">Manager</span>
              </th>
              <th className="px-4 py-3 text-center">
                <span className="badge-editor">Editor</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {permissions.map((p) => (
              <tr key={p.id} className="table-row-hover">
                <td className="px-4 py-2.5 text-sm text-foreground">{p.action}</td>
                <CheckCell has={p.admin} />
                <CheckCell has={p.manager} />
                <CheckCell has={p.editor} />
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}